import {SET_INDICATOR} from './types';

const initialState = {
  indicator: {
    active: true,
    progress: 0,
  },
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_INDICATOR:
      return {
        ...state,
        indicator: {...state.indicator, ...action.payload},
      };

    default:
      return state;
  }
}
export default reducer;
